import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { DiagramModel } from '../../../models';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-diagram-image',
    templateUrl: './diagram-image.component.html',
    styleUrls: ['./diagram-image.component.scss'],
    standalone: false,
})
export class DiagramImageComponent implements OnInit {
    @Input()
    set diagramId(value: string) {
        if (value) {
            this._diagramId = value;
            this.getDiagram();
        } else {
            this._diagramId = value;
            this.diagramItem = null;
            this.diagramPathLowRes = null;
            this.diagramPathHighRes = null;
        }
    }
    get diagramId(): string {
        return this._diagramId;
    }

    @Input()
    set diagramName(value: string) {
        if (value) {
            this._diagramName = value;
            this.getDiagram();
        }
    }
    get diagramName(): string {
        return this._diagramName;
    }
    @Output() diagramData: EventEmitter<DiagramModel> = new EventEmitter<DiagramModel>();

    closeResult: string;
    loading: boolean = false;
    diagramItem: DiagramModel;
    diagramPathLowRes: string;
    diagramPathHighRes: string;

    private _diagramId: string;
    private _diagramName: string;

    constructor(
        private iceapi: IceapiService,
        private modalService: NgbModal,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private user_utility: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService
    ) {}

    ngOnInit(): void {}

    async getDiagram() {
        if (this.diagramId !== undefined || this.diagramName !== undefined) {
            this.ngxUiLoaderService.start();
            await this.iceapi
                .getDiagram(this.diagramId, this.diagramName)
                .toPromise()
                .then((res) => {
                    if (res.success === true) {
                        this.diagramItem = res.response;
                        this.diagramData.emit(res.response);
                    } else {
                        this.user_utility.errorModelPopup(res.message);
                    }
                    this.ngxUiLoaderService.stop();
                })
                .catch((e) => {
                    console.warn(e);
                });
            if (this.diagramItem !== null) {
                if (this.diagramItem.pathLowRes !== null) {
                    this.diagramPathLowRes = this.diagramItem.pathLowRes;
                }
                if (this.diagramItem.pathHighRes !== null) {
                    this.diagramPathHighRes = this.diagramItem.pathHighRes;
                }
                this.cd.markForCheck();
            }
        }
    }

    open(content) {
        if (this.diagramPathHighRes !== undefined) {
            this.modalService
                .open(content, {
                    ariaLabelledBy: 'modal-basic-title',
                    backdrop: 'static',
                    size: 'lg',
                    keyboard: false,
                })
                .result.then(
                    (result) => {
                        this.closeResult = `Closed with: ${result}`;
                    },
                    (reason) => {
                        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                    }
                );
        } else {
            this.customToastService.infoToast('Higher resolution image not available', 'Image not available');
        }
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
}
